import { BaseController } from '../../../base/controller';

export class ChartLabelController extends BaseController {
  constructor(controllerService) {
    'ngInject';
    super({ controllerService });
  }

  handleToggle() {
    this.onToggleFilter();
  }
}
